import { Injectable } from "@angular/core";
import { SharedService } from "../shared/shared.service";
import { appConfig } from "./../app.config";
import { HttpClient } from "@angular/common/http";
import { tap } from 'rxjs/operators';
import { BaseUtils } from "../shared/core/baseUtils.service";

@Injectable()
export class LoginService {
  constructor(
    public sharedService: SharedService,
    private http: HttpClient,
    public baseUtils: BaseUtils
  ) {}

  /**
   * API call for Login
   * @param data User Details
   */
  logIn(data, showSpinner: boolean = false) {
    const loginUrl = appConfig.logIn;
    return this.sharedService.postData(loginUrl, data, showSpinner);
  }

  backOfficeLogin(data, showSpinner: boolean = false) {
    const backOfficeLoginUrl = appConfig.backOfficeLogIn;
    const hardcodeRequestPayload = {
      companyId: 1,
      loginId: data.username,
      password: data.password,
    };
    return this.http.post<any>(backOfficeLoginUrl, hardcodeRequestPayload).pipe(
      tap(
        // Log the result or error
        (result) => {
          return true;
        },

        (error) => {
          this.baseUtils.loading_spinner(false);
          this.baseUtils.toasterMessageAction("error", error.error.message);
        }
      )
    );
  }

  /**
   * API call for Logout
   */
  logOut(showSpinner) {
    const logoutUrl = appConfig.logOut;
    return this.sharedService.deleteData(logoutUrl, showSpinner);
  }
}
